require('normalize.css/normalize.css');
require('styles/App.css');
import React from 'react'
import Time from 'react-time'
import Schedule from './Schedule'
import Calendar from './Calendar'
let imageImage = require('../images/image.png');
let pastImage = require('../images/past.png');
let ispravnoImage = require('../images/ispravno.png');
let yeomanImage = require('../images/alatke.png');
export default class Past extends React.Component {

  render() {
    let now = new Date()
    let wasDate = new Date('Thu Jul 4 1717 16:18:59 GMT+0400')
	let thebestDate = new Date('Thu Jul 4 2016 16:18:59 GMT+0400')
	let themodeDate = new Date('Thu Jul 4 2006 16:18:59 GMT+0400')
    return (
	<div className="index">
	<div className="notice">

        
	 </div>
	
              <div className="scr">
	
      </div>  
	    <div className="footer">
	   <img src={yeomanImage} alt="Yeoman Generator" />
        <p>danas je <Time value={now} format='YYYY/MM/DD' /></p>
		<img src={imageImage} alt="image Generator" />
        <p>updated: <Time value={thebestDate} titleFormat='YYYY/MM/DD HH:mm' relative /></p>
		<img src={pastImage} alt="pastImage" />
        <p>updated: <Time value={themodeDate} titleFormat='YYYY/MM/DD HH:mm' relative /></p><img src={ispravnoImage} alt="ispravnoImage" />
        <p>updated: <Time value={wasDate} titleFormat='YYYY/MM/DD HH:mm' relative /></p>
		
	</div>
	 </div>
    
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Past.js